import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
import { css } from '@bd/bdui-styles/emotion';
import { menuToggler } from '@bd/bdcore-utilities';
import FilterBar from './FilterBar';
import AppliedFilters from './AppliedFilters';
import { colors, typography } from '../styles';

const styles = css`
  display: flex;
  .Filters_button {
    display: inline-flex;
    align-items: center;
    width: 150px;
    position: relative;
    line-height: 1.416667;
    text-align: center;
    cursor: pointer;
    border: solid 1px #E4E4E4;
    border-radius: 3px;
    padding: 0 0 0 15px;
    background-color: #FFFFFF;
    background-image: url('/images/i-arrow-down-gold.svg');
    background-position: calc(100% - 15px) center;
    background-repeat: no-repeat;
    padding: 15px 20px;
    font-family: ${typography.Serif};
    text-transform: uppercase;
    font-weight: 700;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0.96px;
    img {
      margin-right: 11px;
    }
    @media (max-width: 359.98px) {
      width: 135px;
      img {
        margin-right: 8px;
      }
    }
    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }
  .Filters_button-filter {
    background-color: #000000;
    border: solid 2px #FFFFFF;
    border-radius: 0;
    font-size: 14px;
    letter-spacing: .5px;
    margin-right: 4px;
    img {
      width: 29px;
      height: auto;
    }
    @media (max-width: 359.98px) {
      img {
        width: 21px;
      }
    }
    @media (min-width: 620px) {
      margin-right: 10px;
    }
  }
  .Filters_button-sort {
    background-color: #000000;
    border: solid 2px #FFFFFF;
    border-radius: 0;
    letter-spacing: .5px;
    img {
      width: 30px;
      height: auto;
      @media (max-width: 359.98px) {
        width: 22px;
      }
    }
  }
  .Filters_filtersWrapper {
    position: relative;
  }
  .Filters_filterBarWrapper {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    width: 300px;
    overflow: auto;
    background-color: white;
    padding: 15px;
    border-radius: 3px;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.20);
    &.active {
      display: block;
    }
  }
  .Filters_doneBtn {
    margin: 20px 0 0 0;
    padding: 10px 15px;
    font-size: 12px;
    border-radius: 0;
  }
  .Filters_sortWrapper {
    position: relative;
  }
  .Filters_sortDropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 100%;
    list-style: none;
    padding: 10px 15px;
    background: #FFFFFF;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.20);
    background-color: ${colors.color3Lighter};
    z-index: 10;
    border-radius: 3px;
    white-space: nowrap;
  }
  .Filters_sortDropdownItem {
    font-weight: 400;
    font-size: 14px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    &:last-child {
      border: 0;
    }
  }
  .Filters_sortDropdownItem-active {
    font-weight: bold;
  }
  .Filters_sortDropdownButton {
    display: block;
    width: 100%;
    padding: 10px 0;
    cursor: pointer;
  }
`;


function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}


function Filters(props) {
  const {
    activateMenu,
    activeSort,
    isActiveMenu,
    onSortSelect,
    scrollRef,
    sortOptions,
    sortOnly,
  } = props;

  return (
    <div className={styles}>
      { !sortOnly &&
        <div className="Filters_filtersWrapper">
          <button
            className="Filters_button Filters_button-filter"
            type="button"
            onClick={activateMenu('filters')}
          >
            Filter
          </button>
          <div className={`Filters_filterBarWrapper ${isActiveMenu('filters') && 'active'}`}>
            <FilterBar
              {...props}
            />
            <AppliedFilters
              {...props}
              clearButton={<span className="ResetFilter_button">Reset Filters</span>}
            />
            <button className="btn Filters_doneBtn" onClick={activateMenu(null)}>Done</button>
          </div>
        </div>
      }
      <div className="Filters_sortWrapper">
        <button
          className="Filters_button Filters_button-sort Hollow"
          type="button"
          onClick={activateMenu('sort')}
        >
        Sort
        </button>
        {
          isActiveMenu('sort') &&
          <ul className="Filters_sortDropdown">
            { sortOptions.map(option => (
              <li
                className={`Filters_sortDropdownItem ${(activeSort.title === option.title && 'Filters_sortDropdownItem-active') || ''}`.trim()}
                key={option.title}
              >
                <span
                  className="Filters_sortDropdownButton"
                  role="button"
                  tabIndex="0"
                  onClick={() => {
                    scrollToTop(scrollRef);
                    onSortSelect(option);
                  }}
                  onKeyUp={e => {
                    if ([13, 32].includes(e.which)) {
                      scrollToTop(scrollRef);
                      onSortSelect(option);
                    }
                  }}
                >
                  {option.title}
                </span>
              </li>
            ))}
          </ul>
        }
      </div>
    </div>
  );
}

Filters.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  activeSort: PropTypes.object.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onSortSelect: PropTypes.func.isRequired,
  scrollRef: PropTypes.object,
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortOnly: PropTypes.bool,
};

Filters.defaultProps = {
  scrollRef: document.getElementsByTagName('body')[0],
  sortOnly: false,
};

export default menuToggler(Filters);



// WEBPACK FOOTER //
// ./src/components/Filters.js